import Bugsnag from '@bugsnag/js';
import Cookie from 'js-cookie';
import axios, { AxiosRequestConfig } from 'axios';
import { isString } from 'lodash';

import { bugsnag } from 'shared/utils/services/bugsnag';
import { NetworkError, ResourceError } from 'shared/utils/errors';

const handleError = (response) => {
  const status = response?.status;

  switch (true) {
    case status >= 500:
      throw new NetworkError(response);

    case status >= 400:
      if (
        status === 403 &&
        (response?.config?.url?.includes('web-api') ||
          response?.request?.responseURL?.includes('web-api'))
      ) {
        /*
         * Cloudflare bot blocking rules exclusively return a 403,
         * w/ an Access Denied message in the response data
         */
        Bugsnag.leaveBreadcrumb(`Potential Bot Blocked: ${response?.data as string}`);
      }
      throw new ResourceError(response);

    default:
      throw new NetworkError(response);
  }
};

export const setHeaderWithCSRF = () => ({
  'X-CSRF-TOKEN': Cookie.get('csrf'),
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

export const requestService = (options: AxiosRequestConfig) => {
  if (!options.url || !isString(options.url)) {
    throw new Error('Required: url');
  }

  const requestOptions = {
    headers: { ...setHeaderWithCSRF(), ...options.headers },
    method: options.method || 'GET',
    ...options,
  };

  return axios
    .request(requestOptions)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (axios.isCancel(error)) {
        bugsnag(new Error('cancelled (axios) in requestService'), { context: 'requestService' });
      }

      return handleError(error?.response);
    });
};
